
import { select, selectAll } from 'd3-selection';
import store from '@/store';
import {
  computed, defineComponent, ref,
} from '@vue/composition-api';
import { extent } from 'd3-array';
import { formatLongDate, formatShortDate } from '@/lib/utils';

export default defineComponent({
  name: 'TimeLine',

  setup() {
    const slicedNetwork = computed(() => store.state.slicedNetwork);
    const isDate = computed(() => store.state.isDate);

    const currentTime = computed(() => {
      const times: { timeRanges: {[key: number]: number[] | Date[]} ; current: number ; slices: number } = { timeRanges: {}, current: 0, slices: 0 };
      slicedNetwork.value.forEach((slice, i) => {
        times.timeRanges[i] = slice.time;
        times.slices = i + 1;
      });
      return times;
    });
    const timeExtent = computed(() => extent(Object.values(currentTime.value.timeRanges).flat()));
    const textSpacer = ref(50);

    // Update height and width as the window size changes
    const svgDimensions = computed(() => store.state.svgDimensions);
    const timeRangesLength = computed(() => currentTime.value.slices);

    // Tooltip
    const tooltipMessage = ref('');
    const toggleTooltip = ref(false);
    const tooltipPosition = ref({ x: 0, y: 0 });
    const tooltipStyle = computed(() => `left: ${tooltipPosition.value.x}px; top: ${tooltipPosition.value.y}px; white-space: pre-line;`);
    const controlsWidth = computed(() => store.state.controlsWidth);

    function showTooltip(slice: number[], key: number, event: MouseEvent) {
      tooltipPosition.value = {
        x: event.clientX - controlsWidth.value,
        y: event.clientY + 20,
      };
      if (isDate.value) {
        tooltipMessage.value = `Slice: ${key}
      Time: ${formatLongDate(slice[0])} - ${formatLongDate(slice[1])}`;
        toggleTooltip.value = true;
      } else {
        tooltipMessage.value = `Slice: ${key}
      Time: ${Math.floor(slice[0])} - ${Math.floor(slice[1])}`;
        toggleTooltip.value = true;
      }
    }

    function hideTooltip() {
      tooltipMessage.value = '';
      toggleTooltip.value = false;
    }

    // Update time slice view and network
    function updateTime(selection: number) {
      currentTime.value.current = selection;
      selectAll('.timelineRectClass').classed('selected', false);
      select(`#timeSlice_${selection}`).classed('selected', true);

      store.commit.setNetwork(slicedNetwork.value[selection].network);
    }

    return {
      svgDimensions,
      currentTime,
      timeRangesLength,
      showTooltip,
      hideTooltip,
      tooltipStyle,
      toggleTooltip,
      tooltipMessage,
      timeExtent,
      textSpacer,
      updateTime,
      isDate,
      formatShortDate,
    };
  },
});
